import { useState } from "react";
import { useLazyGetCoachingQuery } from "../../slices/coach/coachSlice";
import { Form, Button } from "react-bootstrap";

const CoachScreen = () => {
    const [coachMessages, setCoachMessages] = useState([]);
    const [myMessages, setMyMessages] = useState([]);
    const [message, setMessage] = useState('');

    const [getCoaching, { isFetching, error }] = useLazyGetCoachingQuery();

    const submitGetCoaching = async (e) => {
        e.preventDefault();
        setMyMessages((prevMessages) => [...prevMessages, message]);
        try {
            const res = await getCoaching({ 
                coach: 'hsCoach', 
                message 
            }, { forceRefetch: true });
            setCoachMessages((prevMessages) => [...prevMessages, res.data.coachRes]);
            setMessage('');
        } catch (error) {
            window.alert('Error: ' + (error?.data?.message || error.message));

        }
    }


    return (
        <>
        <div className='coach-box'>
        {myMessages?.map((message, index) => (
            <div key={`messages-${index}`} className='coach-chat'>
                <p className='chat-my-message'>{message}</p>
                <p className='chat-coach-message'>{coachMessages[index] && coachMessages[index]}</p>
            </div>
        ))}
        </div>
        {isFetching && <p>typing...</p>}
        {error && <p>{error}</p>}
        <Form className='coach-box' onSubmit={(e) => submitGetCoaching(e)}>
            <Form.Group controlId={`message`} className="my-2">
                <div className="d-flex">
                    <Form.Control 
                        aria-label="Message to coach"
                        as="textarea"
                        rows={3}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault(); // Prevent newline
                            submitGetCoaching(e); // Trigger form submit
                            }
                        }}
                    />
                    <Button variant="dark" type="submit">Send</Button>
                </div>
            </Form.Group>
        </Form>
        </>
    )
}

export default CoachScreen